import * as constants from './constants';
import {get, post} from "../../../utils/request";
import {ORDER_CREATE, SITE_LIST, VENUE_INFO} from '../../../utils/api';
import history from '../../../utils/history';

export const VenueDetail = (Entity) => ({
    type: constants.VENUE_DETAIL,
    value: Entity
});


export const SiteList = (Entity) => ({
    type: constants.SITE_LIST,
    value: Entity
});

export const CreateOrder = (Entity) => ({
    type: constants.CreateOrder,
    value: Entity
});


export const getVenueDetail = (params) => {
    return (dispatch) => {
        return get(VENUE_INFO + "/" + params, params)
            .then((response) => {
                return dispatch(VenueDetail(response.data));
            });
    }
};

export const getSiteList = (params) => {
    return (dispatch) => {
        return get(SITE_LIST + "/" + params, params)
            .then((response) => {
                return dispatch(SiteList(response.data));
            });
    }
};

export const createOrder = (params) => {
    return (dispatch) => {
        return post(ORDER_CREATE, params)
            .then((response) => {
                if (response.data && response.status === 200) {
                    let {orderId, price} = response.data;
                    history.push('./pay', {orderId, price});
                   // Toast.info(response);
                } else {
                   // Toast.info(response);
                }
            });
    }
};

